import React, { useState } from "react";
import styles from "./ContactUs.module.css";
import axios from "axios";
import promoImg from "../../assets/images/IMG_0068.png";
const ContactUs = () => {
  const [formData, setformData] = useState({
    name: "",
    email: "",
    phone: "",
    query: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    try {
      var { data } = await axios({
        method: "post",
        url: "https://api.cricway.live/api/v1/dj/getContactFormData/apiKey/contact/form/data",
        data: formData,
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      });

      return data;
    } catch (err) {
      return err;
    }
  };

  return (
    <div className={styles.parentContainer}>
      <div className={styles.mainContainer}>
        <h1 className={styles.heading}>Contact Us</h1>

        <div className={styles.cardContainer}>
          <div className={`${styles.firstCard} ${styles.cards}`}>
            <p className={styles.icon}>
              <i class="fa-solid fa-location-dot"></i>
            </p>

            <h2>Address</h2>
            <p class="address contact">G-3, A-84, Sector 4, Noida, UP 201301</p>
          </div>
          <div className={`${styles.secondCard} ${styles.cards}`}>
            <p className={styles.icon}>
              <i class="fa-solid fa-phone"></i>
            </p>

            <h2>Phone</h2>
            <p className={styles.phone}>+91 9560910427</p>
          </div>
          <div className={`${styles.thirdCard} ${styles.cards}`}>
            <p className={styles.icon}>
              <i class="fa-solid fa-envelope"></i>
            </p>

            <h2>Email</h2>
            <p className={styles.email}>info@cricway.live</p>
          </div>
        </div>

        <div className={styles.contactFormContainer}>
          <div className={styles.promoImgContainer}>
            <img src={promoImg} alt="" />
          </div>
          <div className={styles.formContainer}>
            <h2 className={styles.contactFormHeading}>
              Don't Hesitate To Contact
            </h2>

            <form
              className={styles.contactForm}
              id="contact"
              onSubmit={handleSubmit}
              action="https://api.cricway.live/dj/contactUs"
            >
              {/* <label htmlFor="fullName" className="fullnameLabel">Full Name</label> */}
              <input
                type="text"
                id="fullName"
                required
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
              />
              {/* <label htmlFor="email">Email</label> */}
              <input
                type="email"
                id="email"
                name="email"
                required
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
              {/* <label htmlFor="phone">Phone</label> */}
              <input
                type="number"
                id="phone"
                name="phone"
                required
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
              {/* <label htmlFor="query">Query</label> */}
              <textarea
                type="text"
                id="query"
                rows="4"
                cols="50"
                name="query"
                value={formData.query}
                onChange={handleChange}
              >
                {" "}
              </textarea>
              <button className={styles.submitButton} type="submit">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
